
// initialize Firebase app
import { initializeApp } from "firebase/app";
import {    getFirestore} from "firebase/firestore";

// uncomment the following lines when you have your firebaseConfig. Understand what the lines are doing!
import { firebaseConfig } from "./FireBaseconfig";
//import { currentTime, error } from "happy-dom/lib/PropertySymbol";
const app= initializeApp(firebaseConfig);
const db= getFirestore(app);

export{db}
window.db= db;


